/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ClinicalNotesMenuAliases {
  ADD_INSTITUTION_STANDARD_TEXT_ACTION = 'add-institution-standard-text-action',
  ADD_MY_STANDARD_TEXT_ACTION = 'add-my-standard-text-action',
  CLINICAL_NOTES_MENU = 'clinical-notes-menu',
  CONTEXTUAL_BAR_CLINICAL_NOTES_MENU = 'contextual-bar-clinical-notes-menu',
  DELETE_CLINICAL_NOTE_ACTION = 'delete-clinical-note-action',
  INACTIVATE_CLINICAL_NOTE_ACTION = 'inactivate-clinical-note-action',
  NEW_CLINICAL_NOTE_ACTION = 'new-clinical-note-action',
}
export { ClinicalNotesMenuAliases };
